export default "__VITE_ASSET__BqF2_tMP__"